import React, { Ref } from 'react'

function _IconRank(props: React.SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      id="Ranking-Fill--Streamline-Phosphor-Fill"
      height="16"
      width="16"
      {...props}
      ref={ref}
    >
      <path
        d="M15 12.5h-0.5v-3.5a1 1 0 0 0 -1 -1h-2.5V3.5a1 1 0 0 0 -1 -1H6a1 1 0 0 0 -1 1v2H2.5a1 1 0 0 0 -1 1v6h-0.5a0.5 0.5 0 0 0 0 1h14a0.5 0.5 0 0 0 0 -1Zm-10 0H2.5v-6h2.5Zm3.75 -4a0.5 0.5 0 0 1 -1 0v-1.80625l-0.091875 0.030625a0.5 0.5 0 0 1 -0.31625 -0.94875l0.75 -0.25A0.5 0.5 0 0 1 8.75 6Zm4.75 4h-2.5v-3.5h2.5Z"
        strokeWidth="0.0625"
      ></path>
    </svg>
  )
}

export const IconRank = React.forwardRef(_IconRank)
